import type { Attachment } from '@/features/magic/attachment.types';

export const isPdf = (attachment: Attachment): boolean => {
  return Boolean(attachment.contentType?.toLowerCase().includes('pdf'));
};
